import { EntityController } from "./EntityController";
import { PlanManager } from "../../cocosPlan";
import { IdleDecoration } from "../../cocos/scripts/state";
import { Events, eventsManager, RenderCamera, SceneConstants } from "@rhinov/savane-js";



 export class CameraEntityController extends EntityController {

    format: any = null;
    declare entity: RenderCamera;

    constructor(entity: RenderCamera, panel: any, deliverable: any) {
        super(entity, panel, deliverable);
    }

    launchRender(isPreview: boolean) {
        // Commit changes so temporary is destroyed
        var planManager = PlanManager.getInstance();

        (planManager.state as unknown as IdleDecoration).actionEditEnded();
        planManager.updateItemsSelected([]);

        eventsManager.instance.dispatch(Events.COMPUTE_CAMERA_SHOPPING_LIST, this.entity.id);

        var params = {
                        camera_id: this.entity.id,
                        quality: this.entity.quality,
                        preview: isPreview,
                        openpreview: false,
                    };

        if (isPreview) {
            params.openpreview = true;
        }
        eventsManager.instance.dispatch("launchRender", params);
        // scope.hideTab();
    };

    updateProperties(key: string) {
       super.updateProperties(key);
       this.updateCameraProperties();
    }
    
    updateCameraProperties() {
        var fov = document.getElementById('box-fov') as HTMLInputElement;
        var height = document.getElementById('box-height') as HTMLInputElement;
        var pitch = document.getElementById('box-pitch') as HTMLInputElement;
        var renderWidth = document.getElementById('box-renderWidth') as HTMLInputElement;
        var renderHeight = document.getElementById('box-renderHeight') as HTMLInputElement;

        if (!fov || !height || !pitch || !renderWidth || !renderHeight) return;
        if (this.entity.locked) {
            fov.disabled = true;
            height.disabled = true;
            pitch.disabled = true;
            renderWidth.disabled = true;
            renderHeight.disabled = true;
        }
        else {
            if (this.entity.format !== SceneConstants.CameraPreset.Free) {
                renderWidth.disabled = true;
                renderHeight.disabled = true;
            }
            else {
                if (this.entity.cameraType === SceneConstants.CameraType.Panoramic) {
                    renderWidth.disabled = false;
                    renderHeight.disabled = true;
                }
                else {
                    renderWidth.disabled = false;
                    renderHeight.disabled = false;
                }
            }
        }
    }

    decorationDoneAllowed() {
        if (this.deliverable) {
            if (this.deliverable.deliverable_states_id === 7 &&
                this.deliverable.designers_step === 'quality control') {
                    return false;
                }

            return this.deliverable.deliverable_states_id === 2 ||
                this.deliverable.deliverable_states_id === 7 ||
                this.deliverable.deliverable_states_id === 5 ||
                this.deliverable.deliverable_states_id === 10 ||
                this.deliverable.deliverable_states_id === 12;
        }

        return true;
    };

    updatedropDown(prop: any) {
        if (prop.key === "cameraType") {
            if (this.entity.locked) {
                this.format = this.entity.format;
                (document.getElementById("propertycameraType") as HTMLInputElement).disabled = true;
                (document.getElementById("propertyformat") as HTMLInputElement).disabled = true;
            }
            else {
                (document.getElementById("propertycameraType") as HTMLInputElement).disabled = false;
                (document.getElementById("propertyformat") as HTMLInputElement).disabled = false;
            }
        }

        if (prop.key === "format") {
            this.model.format = "" + this.entity.format;
        }
        if (prop.key === "quality") {
            (document.getElementById("propertyquality") as HTMLInputElement).value = this.entity.quality.toString();
        }
    }
}   